<template>
<div class="custom-field" :class="{ 'has-error': error }">
  <label v-if="label" :for="id" class="form-control-label">{{ label }}</label>
  <!-- Adding a wrapper so it's easier to implement stuff like "show password" button. -->
  <div class="custom-field__field-wrapper">
    <slot v-bind="{ id }"></slot>
  </div>
  <TransitionExpand>
    <!-- Needs to be a block, otherwise the transition won't work. -->
    <span v-if="error" class="custom-field__error-text block">{{ error }}</span>
  </TransitionExpand>
</div>
</template>

<script>
import TransitionExpand from '@/components/AsyncTransitionExpand';

export default {
  components: { TransitionExpand },

  props: {
    id: {
      type: String,
      default: () => `custom-input-${Math.random().toString()}`,
    },

    label: {
      type: String,
      required: false,
    },

    error: {
      type: String,
      required: false
    },
  },
}
</script>
